import * as XLSX from 'xlsx';
import { ExportConfig } from '../../types/dashboard';

export function generateExcelExport(config: ExportConfig): void {
  const workbook = XLSX.utils.book_new();

  const rows = config.data.map(row => {
    const mappedRow: Record<string, unknown> = {};
    config.columns.forEach(col => {
      mappedRow[col.header] = row[col.key];
    });
    return mappedRow;
  });

  const worksheet = XLSX.utils.json_to_sheet(rows);

  config.columns.forEach((col, idx) => {
    const colLetter = XLSX.utils.encode_col(idx);
    if (col.width) {
      worksheet['!cols'] = worksheet['!cols'] || [];
      worksheet['!cols'][idx] = { wch: col.width };
    }
  });

  XLSX.utils.book_append_sheet(workbook, worksheet, config.sheetName);

  const metadataSheet = XLSX.utils.aoa_to_sheet([
    ['Report', config.filename],
    ['Generated At', config.generatedAt],
    ['Generated By', config.generatedBy],
    ['Total Rows', config.data.length],
    ...(config.filters
      ? [['Filters', ''], ...Object.entries(config.filters).filter(([, v]) => v).map(([k, v]) => [k, String(v)])]
      : []),
  ]);
  XLSX.utils.book_append_sheet(workbook, metadataSheet, 'Metadata');

  XLSX.writeFile(workbook, `${config.filename}.xlsx`);
}

export function formatCurrency(value: number): string {
  if (value >= 100000) return `Rs ${(value / 100000).toFixed(1)}L`;
  if (value >= 1000) return `Rs ${(value / 1000).toFixed(1)}K`;
  return `Rs ${value}`;
}

export function formatNumber(value: number): string {
  return value.toLocaleString('en-IN');
}
